<template>
	<v-menu
		v-model="show"
		transition="slide-y-transition"
		:close-on-content-click="false"
		max-width="400"
		bottom
		left
		offset-y
	>
		<template #activator="{ on: onMenu }">
			<v-tooltip bottom>
				<template #activator="{ on: onTooltip }">
					<v-btn
						class="toolbar-items"
						icon
						v-on="{ ...onMenu, ...onTooltip }"
					>
						<v-badge
							v-if="notifications.meta.total > 0"
							color="red"
							overlap
						>
							<template slot="badge">
								{{ notifications.meta.total }}
							</template>
							<v-icon color="tertiary">
								mdi-bell
							</v-icon>
						</v-badge>
						<v-icon
							v-else
							color="tertiary"
						>
							mdi-bell
						</v-icon>
					</v-btn>
				</template>
				<span>Уведомления</span>
			</v-tooltip>
		</template>

		<v-toolbar
			color="primary"
			class="white--text"
			flat
			dense
		>
			<v-toolbar-title>
				Непрочитанные уведомления
			</v-toolbar-title>
		</v-toolbar>
		<v-list>
			<template v-if="notifications.data.length">
				<notification-list-item
					v-for="notification in notifications.data"
					:key="notification.id"
					:notification="notification"
					@open="readNotificationAndCloseList"
					@read="readNotification"
				/>
			</template>
			<v-list-item v-else>
				<v-list-item-content>
					<v-list-item-title>
						У вас нет непрочитанных уведомлений
					</v-list-item-title>
				</v-list-item-content>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import NotificationListItem from '@/components/notifications/notification-item';
import NotificationMapper from '@/utils/notification-mapper';

const STORE_AUTH = createNamespacedHelpers('auth');

const NOTIFICATION_MAPPER = new NotificationMapper();

export default {
	name: 'AppNotifications',
	components: { NotificationListItem },
	data: () => ({
		show: false,
		notifications: {
			data: [],
			meta: {
				total: 0,
			},
		},
	}),
	computed: {
		...STORE_AUTH.mapState([ 'user' ]),
		channel() {
			return `user.${this.user.id}`;
		},
	},
	async mounted() {
		await this.fetchNotifications();
	},
	methods: {
		async fetchNotifications() {
			try {
				const response = await this.$http.get('api/v1/notifications');
				this.notifications = response.data;
			} catch (e) {
				this.$notify.error('Ошибка получения уведомлений');
			}
		},
		prependNotification(notification) {
			this.notifications.data.unshift(notification);
			this.notifications.meta.total++;
		},
		toastNotification(notification) {
			const mapped = NOTIFICATION_MAPPER.execute(notification);
			this.$notify.success(mapped.title, {
				slot: [this.$createElement('button', {
					domProps: {
						innerHTML: mapped.linkTitle,
					},
					on: {
						click: async () => {
							const cmp = this.$notify.getCmp();
							cmp.close();
							await this.$router.push(mapped.to);
							await this.readNotification(notification);
						},
					}
				})]
			});
		},
		async readNotification(notification) {
			try {
				await this.$http.post(`/api/v1/notifications/${notification.id}/markAsRead`);
				this.notifications.data = this.notifications.data.filter(n => n.id !== notification.id);
				this.notifications.meta.total--;
			} catch (e) {
				console.error(e);
			}
		},
		async readNotificationAndCloseList(notification) {
			this.show = false;
			await this.readNotification(notification);
		},
	},
};
</script>

<style scoped>

</style>
